/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { ApproveOrRejectWorkflowInstanceRequest } from '../models/approve-or-reject-workflow-instance-request';
import { ApproveWorkflowInstanceByUserRequest } from '../models/approve-workflow-instance-by-user-request';
import { CancelWorkflowInstanceRequest } from '../models/cancel-workflow-instance-request';
import { CreateWorkflowInstanceRequest } from '../models/create-workflow-instance-request';
import { GenericResponse } from '../models/generic-response';
import { GetWorkflowInstanceResponse } from '../models/get-workflow-instance-response';
import { WorkflowAdvanceInstanceResponse } from '../models/workflow-advance-instance-response';
import { WorkflowAdvanceInstanceStageResponse } from '../models/workflow-advance-instance-stage-response';
import { WorkflowInstanceCancelResponse } from '../models/workflow-instance-cancel-response';
import { WorkflowInstanceResponse } from '../models/workflow-instance-response';
import { WorkflowInstanceStatus } from '../models/workflow-instance-status';

@Injectable({ providedIn: 'root' })
export class WorkflowInstanceService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllWorkflowInstance()` */
  static readonly GetAllWorkflowInstancePath = '/api/v1/workflows/instance';

  /**
   * get all workflow instance.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllWorkflowInstance()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllWorkflowInstance$Response(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a filtering stage by admin id
       */
      adminId?: number;

      /**
       * This adds a string search to the following fields.
       * - name
       * - description
       */
      search?: string;

      /**
       * This adds a filtering stage by workflow id
       */
      workflowId?: number;

      /**
       * This adds a filtering stage by created by id
       */
      createdBy?: number;

      /**
       * This adds a filtering workflow-instance by category id
       */
      categoryId?: number;

      /**
       * This adds a filtering workflow-instance by department id
       */
      departmentId?: number;

      /**
       * This adds a filtering workflow-instance by status
       */
      status?: WorkflowInstanceStatus;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetWorkflowInstanceResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      WorkflowInstanceService.GetAllWorkflowInstancePath,
      'get'
    );
    if (params) {
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('sort', params.sort, {});
      rb.query('adminId', params.adminId, {});
      rb.query('search', params.search, {});
      rb.query('workflowId', params.workflowId, {});
      rb.query('createdBy', params.createdBy, {});
      rb.query('categoryId', params.categoryId, {});
      rb.query('departmentId', params.departmentId, {});
      rb.query('status', params.status, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GetWorkflowInstanceResponse>;
        })
      );
  }

  /**
   * get all workflow instance.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllWorkflowInstance$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllWorkflowInstance(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a filtering stage by admin id
       */
      adminId?: number;

      /**
       * This adds a string search to the following fields.
       * - name
       * - description
       */
      search?: string;

      /**
       * This adds a filtering stage by workflow id
       */
      workflowId?: number;

      /**
       * This adds a filtering stage by created by id
       */
      createdBy?: number;

      /**
       * This adds a filtering workflow-instance by category id
       */
      categoryId?: number;

      /**
       * This adds a filtering workflow-instance by department id
       */
      departmentId?: number;

      /**
       * This adds a filtering workflow-instance by status
       */
      status?: WorkflowInstanceStatus;
    },
    context?: HttpContext
  ): Observable<GetWorkflowInstanceResponse> {
    return this.getAllWorkflowInstance$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<GetWorkflowInstanceResponse>
        ): GetWorkflowInstanceResponse => r.body
      )
    );
  }

  /** Path part for operation `createWorkflowInstance()` */
  static readonly CreateWorkflowInstancePath = '/api/v1/workflows/instance';

  /**
   * create new workflow instance.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createWorkflowInstance()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createWorkflowInstance$Response(
    params: {
      body: CreateWorkflowInstanceRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkflowInstanceResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      WorkflowInstanceService.CreateWorkflowInstancePath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<WorkflowInstanceResponse>;
        })
      );
  }

  /**
   * create new workflow instance.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createWorkflowInstance$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createWorkflowInstance(
    params: {
      body: CreateWorkflowInstanceRequest;
    },
    context?: HttpContext
  ): Observable<WorkflowInstanceResponse> {
    return this.createWorkflowInstance$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<WorkflowInstanceResponse>
        ): WorkflowInstanceResponse => r.body
      )
    );
  }

  /** Path part for operation `getWorkflowInstanceById()` */
  static readonly GetWorkflowInstanceByIdPath =
    '/api/v1/workflows/instance/{id}';

  /**
   * get workflow instance by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWorkflowInstanceById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWorkflowInstanceById$Response(
    params: {
      /**
       * The workflow instance id that needs to be fetched
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkflowAdvanceInstanceResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      WorkflowInstanceService.GetWorkflowInstanceByIdPath,
      'get'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<WorkflowAdvanceInstanceResponse>;
        })
      );
  }

  /**
   * get workflow instance by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWorkflowInstanceById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWorkflowInstanceById(
    params: {
      /**
       * The workflow instance id that needs to be fetched
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkflowAdvanceInstanceResponse> {
    return this.getWorkflowInstanceById$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<WorkflowAdvanceInstanceResponse>
        ): WorkflowAdvanceInstanceResponse => r.body
      )
    );
  }

  /** Path part for operation `disableWorkflowInstanceById()` */
  static readonly DisableWorkflowInstanceByIdPath =
    '/api/v1/workflows/instance/{id}';

  /**
   * disable workflow instance by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `disableWorkflowInstanceById()` instead.
   *
   * This method doesn't expect any request body.
   */
  disableWorkflowInstanceById$Response(
    params: {
      /**
       * The workflow instance id that needs to be soft deleted
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      WorkflowInstanceService.DisableWorkflowInstanceByIdPath,
      'delete'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * disable workflow instance by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `disableWorkflowInstanceById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  disableWorkflowInstanceById(
    params: {
      /**
       * The workflow instance id that needs to be soft deleted
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.disableWorkflowInstanceById$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }

  /** Path part for operation `getWorkflowInstanceStages()` */
  static readonly GetWorkflowInstanceStagesPath =
    '/api/v1/workflows/instance/{id}/stage';

  /**
   * get workflow instance stage history by instance id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWorkflowInstanceStages()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWorkflowInstanceStages$Response(
    params: {
      /**
       * The workflow instance id that needs to be fetch stage audited data
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkflowAdvanceInstanceStageResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      WorkflowInstanceService.GetWorkflowInstanceStagesPath,
      'get'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<WorkflowAdvanceInstanceStageResponse>;
        })
      );
  }

  /**
   * get workflow instance stage history by instance id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWorkflowInstanceStages$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWorkflowInstanceStages(
    params: {
      /**
       * The workflow instance id that needs to be fetch stage audited data
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkflowAdvanceInstanceStageResponse> {
    return this.getWorkflowInstanceStages$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<WorkflowAdvanceInstanceStageResponse>
        ): WorkflowAdvanceInstanceStageResponse => r.body
      )
    );
  }

  /** Path part for operation `approveOrRejectWorkflowInstanceById()` */
  static readonly ApproveOrRejectWorkflowInstanceByIdPath =
    '/api/v1/workflows/instance/{id}/stage';

  /**
   * approve or reject workflow instance by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `approveOrRejectWorkflowInstanceById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  approveOrRejectWorkflowInstanceById$Response(
    params: {
      /**
       * The workflow instance id that need to be approved or rejected
       */
      id: number;
      body: ApproveOrRejectWorkflowInstanceRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkflowInstanceResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      WorkflowInstanceService.ApproveOrRejectWorkflowInstanceByIdPath,
      'post'
    );
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<WorkflowInstanceResponse>;
        })
      );
  }

  /**
   * approve or reject workflow instance by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `approveOrRejectWorkflowInstanceById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  approveOrRejectWorkflowInstanceById(
    params: {
      /**
       * The workflow instance id that need to be approved or rejected
       */
      id: number;
      body: ApproveOrRejectWorkflowInstanceRequest;
    },
    context?: HttpContext
  ): Observable<WorkflowInstanceResponse> {
    return this.approveOrRejectWorkflowInstanceById$Response(
      params,
      context
    ).pipe(
      map(
        (
          r: StrictHttpResponse<WorkflowInstanceResponse>
        ): WorkflowInstanceResponse => r.body
      )
    );
  }

  /** Path part for operation `cancelWorkFlowInstanceById()` */
  static readonly CancelWorkFlowInstanceByIdPath =
    '/api/v1/workflows/instance/{id}/cancel';

  /**
   * cancel workflow instance by id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cancelWorkFlowInstanceById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cancelWorkFlowInstanceById$Response(
    params: {
      /**
       * The workflow instance id that need to be cancelled
       */
      id: number;
      body: CancelWorkflowInstanceRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkflowInstanceCancelResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      WorkflowInstanceService.CancelWorkFlowInstanceByIdPath,
      'post'
    );
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<WorkflowInstanceCancelResponse>;
        })
      );
  }

  /**
   * cancel workflow instance by id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `cancelWorkFlowInstanceById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  cancelWorkFlowInstanceById(
    params: {
      /**
       * The workflow instance id that need to be cancelled
       */
      id: number;
      body: CancelWorkflowInstanceRequest;
    },
    context?: HttpContext
  ): Observable<WorkflowInstanceCancelResponse> {
    return this.cancelWorkFlowInstanceById$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<WorkflowInstanceCancelResponse>
        ): WorkflowInstanceCancelResponse => r.body
      )
    );
  }

  /** Path part for operation `approveWorkflowInstanceByUser()` */
  static readonly ApproveWorkflowInstanceByUserPath =
    '/api/v1/workflows/instance/users';

  /**
   * approve workflow instance by user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `approveWorkflowInstanceByUser()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  approveWorkflowInstanceByUser$Response(
    params: {
      body: ApproveWorkflowInstanceByUserRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      WorkflowInstanceService.ApproveWorkflowInstanceByUserPath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * approve workflow instance by user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `approveWorkflowInstanceByUser$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  approveWorkflowInstanceByUser(
    params: {
      body: ApproveWorkflowInstanceByUserRequest;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.approveWorkflowInstanceByUser$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }

  /** Path part for operation `getWorkflowInstanceExists()` */
  static readonly GetWorkflowInstanceExistsPath = '/api/v1/workflows-instance';

  /**
   * get the workflow instance exists or not.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getWorkflowInstanceExists()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWorkflowInstanceExists$Response(
    params?: {
      /**
       * This adds a filtering workflow-instance by department id
       */
      departmentId?: number;

      /**
       * This adds a filtering workflow-instance by category id
       */
      categoryId?: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      WorkflowInstanceService.GetWorkflowInstanceExistsPath,
      'get'
    );
    if (params) {
      rb.query('departmentId', params.departmentId, {});
      rb.query('categoryId', params.categoryId, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * get the workflow instance exists or not.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getWorkflowInstanceExists$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getWorkflowInstanceExists(
    params?: {
      /**
       * This adds a filtering workflow-instance by department id
       */
      departmentId?: number;

      /**
       * This adds a filtering workflow-instance by category id
       */
      categoryId?: number;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.getWorkflowInstanceExists$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }
}
